import { CoverTableModule } from './../cover-table/cover-table.module';
import { CoverThumbnailModule } from './../cover-thumbnail/cover-thumbnail.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CarRoutingModule } from './car-routing.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FooterModule } from 'app/shared/footer/footer.module';
import { MenuModule } from 'app/shared/menu/menu.module';
import { TrustpilotModule } from 'app/shared/trustpilot/trustpilot.module';
import { TopbarModule } from 'app/shared/topbar/topbar.module';
import { FaqModule } from 'app/shared/faq/faq.module';
import { CustomModalModule } from 'app/shared/custommodal/custommodal.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CoverComponent } from './components/_cover/_cover.component';
import { IndexComponent } from './components/index/index.component';
import { CalculateButtonModule } from 'app/shared/calculate-button/calculate-button.module';
import { NicetoknowModule } from '../nicetoknow/nicetoknow.module';
import { PageLoaderModule } from 'app/shared/pageloader/pageloader.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CustomPipeModule } from 'app/class/pipe/custompipe.module';

@NgModule({
    imports: [
        CarRoutingModule,
        CommonModule,
        FormsModule,
        FooterModule,
        MenuModule,
        TrustpilotModule,
        TopbarModule,
        TooltipModule,
        ModalModule,
        CustomModalModule,
        FaqModule,
        CalculateButtonModule,
        NicetoknowModule,
        PageLoaderModule,
        TranslateModule,
        CustomPipeModule,
        CoverThumbnailModule,
        CoverTableModule,
    ],
    declarations: [CoverComponent, IndexComponent],
    exports: [CoverComponent],
})
export class CarModule {}
